import React, {useState, useEffect, useRef} from "react";
import {useObserver} from "Hooks/useObserver";
import {Lazy} from "./LazyComponent";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {css} from "styled-components";

const LazyImage = ({
                       source,
                       height,
                       timeout = 200,
                       display,
                       borderRadius,
                       alt,
                   }) => {
    const domRef = useRef();
    const [isVisible, setVisible] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);

    const observe = useObserver(domRef);
    useEffect(() => {
        if (!isVisible && observe) {
            setVisible(true);
        }
    }, [observe]);

    useEffect(() => {
        if (isVisible) {
            setTimeout(() => setFadeIn(isVisible), timeout);
        }
    }, [isVisible]);

    return (
        <Lazy onload={fadeIn} ref={domRef} display={display} height="100%">
            <SpanInLazy display={display} height={height}>
                {isVisible && (
                    <ImageInLazy src={source} borderRadius={borderRadius} alt={alt}/>
                )}
            </SpanInLazy>
        </Lazy>
    );
};

export default LazyImage;

export const ImageInLazy = styled.img.attrs(({alt}) => ({
    alt: alt || "",
}))`
    object-fit: cover;
    max-width: 100%;
    border-radius: ${({borderRadius}) => (borderRadius ? borderRadius : "0")};
    alt: ${({alt}) => alt};
`;

export const SpanInLazy = styled.span.attrs(({display, height}) => ({height: height ? height : undefined}))`
    ${({display}) =>
            display &&
            css`
                display: flex;
            `}
    max-height: ${({height}) => (height ? height : "239px")};
    min-height: ${({height}) => (height ? height : "239px")};
    ${media.greaterThan(breakpoints.mobile)`		
        max-height: ${({height}) => (height ? height : "800px")};
    `};
`;
